






























































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { userUtils } from "../../_utils/userUtils";
import * as auth from "../../_store/auth.module";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import DocPreviewDialog from "../../components/Dialogs/DocPreviewDialog.vue";
import { InstituteInfo } from "../../_models/instituteInfo";
import { DocNominaResponsabileInfo } from "../../_models/docNominaResponsabileInfo";

@Component({
  components: {
    DocPreviewDialog
  }
})
export default class NominaResponsabile extends Vue {
  @Prop() idIstituto!: string;
  @Prop() idDoc!: number;
  private docElements: DocNominaResponsabileInfo;
  private accettato: boolean;
  // private denominazioneAzienda: string;
  // private idAzienda: number;
  // private nomeIstituto: string;
  // private todayDate: string;
  private img1Picked: boolean;
  // private selected

  constructor() {
    super();
    this.docElements = {
      nomeIstituto: "",
      nomeAzienda: "",
      idAzienda: 0,
      idIstituto: 0,
      dataDocumento: "",
      firmaUno: "",
      firmaDue: "",
      idDoc: 0
    };
    // this.denominazioneAzienda = "";
    // this.idAzienda = 0;
    // this.nomeIstituto = "";
    // this.todayDate = "";
    this.img1Picked = false;
    this.accettato = false;
  }

  clearFirstSignature() {
    //@ts-ignore
    this.$refs.firstSignaturePad.clearSignature();
  }

  clearSecondSignature() {
    //@ts-ignore
    this.$refs.secondSignaturePad.clearSignature();
  }

  onPickFile() {
    //@ts-ignore
    this.$refs.fileInput.click();
  }

  onFilePicked() {
    //@ts-ignore
    var file = document.getElementById("filePicker").files[0];
    if (file !== null && file !== undefined && file.size < 3000000) {
      //!!!!!!!DIMENSIONE FILE PROVVISORIA

      if (
        file.type === "application/pdf" ||
        file.type === "image/tiff" ||
        file.type === "image/jpeg"
      ) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          var fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size / 1000) + " kB",
            base64: reader.result
          };
        };
      } else {
        bus.$emit(
          "errorOperation",
          "Estensione file selezionato non supportato (estensioni valide: .pdf, .jpg, .tif)"
        );
      }
    } else {
      bus.$emit(
        "errorOperation",
        "La dimensione del file selezionato supera la dimesione massima consentita"
      );
    }
  }

  save() {
    var IdAzienda = this.docElements.idAzienda;
    var signatureAllievoEmpty: boolean = true;
    var signatureTutoreEmpty: boolean = true;
    //@ts-ignore
    const signatureUno = this.$refs.firstSignaturePad.saveSignature();
    //@ts-ignore
    const signatureDue = this.$refs.secondSignaturePad.saveSignature();
    if (signatureUno.isEmpty === false && signatureDue.isEmpty === false) {
      const payload = {
        firmaUno: signatureUno.data,
        firmaDue: signatureDue.data,
        idAzienda: IdAzienda,
        idIstituto: this.docElements.idIstituto,
        nomeIstituto: this.docElements.nomeIstituto,
        nomeAzienda: this.docElements.nomeAzienda,
        dataDocumento: this.docElements.dataDocumento,
        docType: "nominaResponsabile",
        idDoc: this.idDoc
      };
      this.docElements.firmaUno = signatureUno.data;
      this.docElements.firmaDue = signatureDue.data;
      bus.$emit("openDocResponsabilePreview", payload);
      // bus.$emit("createDoc")
      // user
      //   .dispatchResponsabileDatiDoc(this["$store"], this.docElements)
      //   .then(() => {
      //     bus.$emit("successfullOperation", "Documento inviato con successo");
      //     this["$router"].push("/moduli");
      //   })
      //   .catch(error => {
      //     bus.$emit("errorOperation", error.response.data.message);
      //   });
    } else {
      bus.$emit("errorOperation", "Una o più firme sono mancanti");
    }
  }

  back() {
    this["$router"].push("/moduli");
  }

  created() {
    var enterpriseInfo: EnterpriseInfo;
    var instituteInfo: InstituteInfo;
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetEnterpriseInfo(this["$store"])
          .then(() => {
            data
              .dispatchInstituteInfo(this["$store"], this.idIstituto)
              .then(result => {
                // this.nomeIstituto = result.ragioneSocialeIstituto;
                enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
                // this.denominazioneAzienda = enterpriseInfo.denominazioneAzienda;
                // this.idAzienda = enterpriseInfo.id;
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, "0");
                var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
                var yyyy = today.getFullYear();

                // this.todayDate = dd + "/" + mm + "/" + yyyy;
                this.docElements = {
                  nomeIstituto: result.ragioneSocialeIstituto,
                  nomeAzienda: enterpriseInfo.denominazioneAzienda,
                  idAzienda: enterpriseInfo.idAzienda,
                  idIstituto: result.id,
                  dataDocumento: dd + "/" + mm + "/" + yyyy,
                  firmaUno: "",
                  firmaDue: "",
                  idDoc: 0
                };
                bus.$emit("loadMenu");
              })
              .catch(() => {
                bus.$emit("stopLoading");
                auth.dispatchLogout(this["$store"]);
                user.dispatchClearState(this["$store"]);
                this["$router"].push("/sessionExpired");
              });
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
